import { render, staticRenderFns } from "./CommandDefinition.vue?vue&type=template&id=1d2db83a&scoped=true&"
import script from "./CommandDefinition.vue?vue&type=script&lang=js&"
export * from "./CommandDefinition.vue?vue&type=script&lang=js&"
import style0 from "./CommandDefinition.vue?vue&type=style&index=0&id=1d2db83a&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2db83a",
  null
  
)

export default component.exports